import headerLogo from '../../../public/fx-header-logo-white.png'

export default function FullFxLogo() {
  return (
    <img src={headerLogo} alt="Floorplan Xpress" className="absolute top-0 bottom-0 right-0 left-0 m-auto h-10" />
  )
}